"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onToggleSingle = exports.onToggleMulti = exports.onNavigation = void 0;
const keys = {
  end: 35,
  home: 36,
  up: 38,
  down: 40
};
const collapseAll = (openedItems, setOpenedStates) => {
  const buf = openedItems;
  Object.keys(buf).forEach(k => {
    buf[k] = false;
  });
  setOpenedStates({
    ...openedItems,
    ...buf
  });
};
const onToggleMulti = (id, openedItems, setOpenedStates) => {
  if (openedItems[id]) {
    collapseAll(openedItems, setOpenedStates);
  } else {
    collapseAll(openedItems, setOpenedStates);
    setOpenedStates({
      ...openedItems,
      [id]: !openedItems[id]
    });
  }
};
exports.onToggleMulti = onToggleMulti;
const onToggleSingle = (id, openedItems, setOpenedStates) => {
  setOpenedStates({
    ...openedItems,
    [id]: !openedItems[id]
  });
};
exports.onToggleSingle = onToggleSingle;
const firstAvailableItem = disabledItems => {
  let index = -1;
  let found = false;
  let counter = 0;
  while (!found) {
    if (!disabledItems[counter]) {
      index = counter;
      found = true;
    }
    counter++;
  }
  return index;
};
const lastAvailableItem = disabledItems => {
  let index = -1;
  let found = false;
  const lastIndex = disabledItems.length - 1;
  let counter = lastIndex;
  while (!found) {
    if (!disabledItems[counter]) {
      index = counter;
      found = true;
    }
    counter--;
  }
  return index;
};
const prevAvailableItem = (current, disabledItems) => {
  const lastIndex = disabledItems.length - 1;
  let index = -1;
  let found = false;
  let counter = current <= 0 ? lastIndex : current - 1;
  while (!found) {
    if (!disabledItems[counter]) {
      index = counter;
      found = true;
    } else {
      counter = counter <= 0 ? lastIndex : counter - 1;
    }
  }
  return index;
};
const nextAvailableItem = (current, disabledItems) => {
  const lastIndex = disabledItems.length - 1;
  let index = -1;
  let found = false;
  let counter = current >= lastIndex ? 0 : current + 1;
  while (!found) {
    if (!disabledItems[counter]) {
      index = counter;
      found = true;
    } else {
      counter = counter >= lastIndex ? 0 : counter + 1;
    }
  }
  return index;
};
const onNavigation = (setSelectedState, disabledItems, key, focusRef) => {
  switch (key) {
    case keys.down:
      setSelectedState(nextAvailableItem(focusRef.current, disabledItems));
      break;
    case keys.up:
      setSelectedState(prevAvailableItem(focusRef.current, disabledItems));
      break;
    case keys.home:
      setSelectedState(firstAvailableItem(disabledItems));
      break;
    case keys.end:
      setSelectedState(lastAvailableItem(disabledItems));
      break;
    default:
      break;
  }
};
exports.onNavigation = onNavigation;